import type { FC } from "react";

import { ColoredLabel } from "widgets";

import type { IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import { getCssColor } from "@/app-utils/color.ts";
import type { Sample } from "@/graphql.js";

const StatusCell: FC<IAgGridCellProps> = (props) => {
  const sample = props.data as Sample;
  if (sample == null) {
    return null;
  }

  return (
    <TableCell>
      <ColoredLabel
        color={sample.status.color ? getCssColor(sample.status.color) : undefined}
        label={sample.status.name}
      />
    </TableCell>
  );
};

export default StatusCell;
